import { defineMessages } from 'react-intl';

export default defineMessages({
	lblTitle: {
		id: 'app.ouigoRefunds.title',
		defaultMessage: 'Ouigo Refunds',
	},
	lblAvailable: {
		id: 'app.ouigoRefunds.available',
		defaultMessage: 'Available',
	},
	lblArchive: {
		id: 'app.ouigoRefunds.archive',
		defaultMessage: 'Archive',
	},
	lblSupplyChannelRecordLocator: {
		id: 'app.ouigoRefunds.supplyChannelRecordLocator',
		defaultMessage: 'Supply Channel Record Locator',
	},
	lblBookingLocator: {
		id: 'app.ouigoRefunds.bookingLocator',
		defaultMessage: 'Booking Locator',
	},
	lblVoucherNumber: {
		id: 'app.ouigoRefunds.voucherNumber',
		defaultMessage: 'Voucher no.',
	},
	lblIssueDate: {
		id: 'app.ouigoRefunds.issueDate',
		defaultMessage: 'Issue date',
	},
	lblFinalisedDate: {
		id: 'app.ouigoRefunds.finalisedDate',
		defaultMessage: 'Finalised date',
	},
	lblValue: {
		id: 'app.ouigoRefunds.value',
		defaultMessage: 'Value',
	},
	lblSelectAll: {
		id: 'app.ouigoRefunds.selectAll',
		defaultMessage: 'Select all',
	},
	lblClearAll: {
		id: 'app.ouigoRefunds.clearAll',
		defaultMessage: 'Clear all',
	},
	lblSelectVoucher: {
		id: 'app.ouigoRefunds.selectVoucher',
		defaultMessage: 'Select voucher {voucherNumber}',
	},
	lblDeselectVoucher: {
		id: 'app.ouigoRefunds.deselectVoucher',
		defaultMessage: 'Deselect voucher {voucherNumber}',
	},
	lblSubmitForRefund: {
		id: 'app.ouigoRefunds.submitForRefund',
		defaultMessage: 'Submit for refund',
	},
	lblClose: {
		id: 'app.ouigoRefunds.close',
		defaultMessage: 'Close',
	},
	lblRangeFrom: {
		id: 'app.ouigoRefunds.rangeFrom',
		defaultMessage: 'Range from',
	},
	lblRangeTo: {
		id: 'app.ouigoRefunds.rangeTo',
		defaultMessage: 'Range to',
	},
	lblApply: {
		id: 'app.ouigoRefunds.apply',
		defaultMessage: 'Apply',
	},
	lblDownloadCsv: {
		id: 'app.ouigoRefunds.downloadCsv',
		defaultMessage: 'Download CSV',
	},
	lblUnableToDownloadCsv: {
		id: 'app.ouigoRefunds.unableToDownloadCsv',
		defaultMessage: 'Unable to download the CSV file. Please try again.',
	},
	lblShowingResults: {
		id: 'app.ouigoRefunds.showingResults',
		defaultMessage: 'Showing {resultStart}-{resultEnd} of {resultTotal}',
	},
	lblMonth: {
		id: 'app.ouigoRefunds.month',
		defaultMessage: 'Month',
	},
	lblYear: {
		id: 'app.ouigoRefunds.year',
		defaultMessage: 'YYYY',
	},
	lblNoVouchersFound: {
		id: 'app.ouigoRefunds.noVouchersFound',
		defaultMessage: 'No vouchers found',
	},
	lblNoVouchersFoundDescription: {
		id: 'app.ouigoRefunds.noVouchersFoundDescription',
		defaultMessage:
			'There are no vouchers found for this time period. Please change the date range and try again.',
	},
	lblUnableToLoadVouchers: {
		id: 'app.ouigoRefunds.unableToLoadVouchers',
		defaultMessage: 'Unable to load vouchers',
	},
	lblUnableToLoadVouchersDescription: {
		id: 'app.ouigoRefunds.unableToLoadVouchersDescription',
		defaultMessage: 'There was a problem loading vouchers. Please try again.',
	},
	lblFetchingVouchers: {
		id: 'app.ouigoRefunds.fetchingVouchers',
		defaultMessage: 'Fetching vouchers',
	},
});
